import React, { createContext, useContext, useState, useEffect } from 'react';
import authUser from '../api/authUser';

export const UserContext = createContext();

const UserContextProvider = (props) => {
  const initialState = {
    loading: false,
    user: null,
    error: null
  };

  const [userState, setUserState] = useState({ user: 'loading' });

  useEffect(() => {
    authUser(setUserState, initialState);
    // eslint-disable-next-line
  }, []);

  return <UserContext.Provider value={{ userState, setUserState }}>{props.children}</UserContext.Provider>;
};

export default UserContextProvider;

// CUSTOM HOOK - Get user
export const useGetUser = () => {
  const { userState } = useContext(UserContext);
  const user = userState.user;
  return user;
};

// CUSTOM HOOK - Set user
export const useSetUser = () => {
  const { setUserState } = useContext(UserContext);
  const setUser = (user) => setUserState((prev) => ({ ...prev, user }));
  return setUser;
};

// CUSTOM HOOK - Login user
export const useLoginUser = () => {};
